import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow } from "vue";
import _imports_0 from '@/assets/icons/new-tab.svg';
import _imports_1 from '@/assets/icons/kizuna-logo.svg';
import _imports_2 from '@/assets/icons/close-dialog.svg';
import _imports_3 from '@/assets/mintview/mint-panels/pending-approval.png';
import _imports_4 from '@/assets/mintview/mint-panels/minting.gif';
import _imports_5 from '@/assets/mintview/mint-panels/success.gif';
import _imports_6 from '@/assets/mintview/mint-panels/failed.png';
const _hoisted_1 = {
  class: "mint-panels-container"
};
const _hoisted_2 = {
  class: "mint-panels-container"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "link",
  target: "_blank"
}, [/*#__PURE__*/_createTextVNode(" WHAT IS"), /*#__PURE__*/_createElementVNode("br", {
  class: "hidden-lg-and-up"
}), /*#__PURE__*/_createTextVNode(" KIZUNA? "), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "New tab",
  class: "icon hidden-md-and-down"
})], -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_1,
  alt: "Kizuna"
}, null, -1);
const _hoisted_5 = {
  key: 0,
  class: "welcome"
};
const _hoisted_6 = {
  class: "mint-progress-container"
};
const _hoisted_7 = {
  class: "header"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "PHASE |", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "| MINTED", -1);
const _hoisted_10 = {
  class: "progress-bar-container"
};
const _hoisted_11 = {
  class: "panels-container hidden-lg-and-up"
};
const _hoisted_12 = {
  class: "panels-container hidden-md-and-down"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "characters",
  src: _imports_3
}), /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Pending Approval"), /*#__PURE__*/_createElementVNode("p", {
  class: "info"
}, [/*#__PURE__*/_createTextVNode(" Approve the transaction in your"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" web3 wallet to mint. ")])], -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "characters",
  src: _imports_4
}), /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Minting!"), /*#__PURE__*/_createElementVNode("p", {
  class: "info"
}, [/*#__PURE__*/_createTextVNode(" Please wait while the transaction"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" is being confirmed on-chain. ")])], -1);
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1);
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "characters",
  src: _imports_5
}), /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Success!"), /*#__PURE__*/_createElementVNode("p", {
  class: "info"
}, "Welcome to Lunaria!")], -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1);
const _hoisted_20 = {
  class: "content"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "characters",
  src: _imports_6
}, null, -1);
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Transaction Failed!", -1);
const _hoisted_23 = {
  key: 0,
  class: "info error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_PublicPanel = _resolveComponent("PublicPanel");
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_Phase1LunarPanel = _resolveComponent("Phase1LunarPanel");
  const _component_Phase2LunarPanel = _resolveComponent("Phase2LunarPanel");
  const _component_AstralPanel = _resolveComponent("AstralPanel");
  const _component_el_carousel = _resolveComponent("el-carousel");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_SuccessComicPage = _resolveComponent("SuccessComicPage");
  const _directive_touch = _resolveDirective("touch");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    text: true,
    link: true,
    class: "what-is-kizuna-button"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _hoisted_4, _ctx.isWalletConnected ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Hello, Seeker .//" + _toDisplayString(_ctx.truncateWalletAddress(_ctx.walletAddress)), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, [_hoisted_8, _createTextVNode(" " + _toDisplayString(_ctx.currentActivePhase), 1)]), _createElementVNode("p", null, [_createTextVNode(_toDisplayString(_ctx.formatUnits(_ctx.totalSupply, 0)) + "/" + _toDisplayString(_ctx.formatUnits(_ctx.maxSupply, 0)) + " ", 1), _hoisted_9])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_slider, {
    "model-value": +_ctx.formatUnits(_ctx.totalSupply, 0),
    min: 0,
    max: +_ctx.formatUnits(_ctx.maxSupply, 0),
    "show-tooltip": false,
    disabled: true
  }, null, 8, ["model-value", "max"])])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_carousel, {
    ref: "carousel",
    arrow: "always",
    loop: false,
    autoplay: false,
    "indicator-position": "outside",
    height: "435px",
    "initial-index": !_ctx.isPhase1LunarMintPaused || !_ctx.isPhase2LunarMintPaused ? 1 : !_ctx.isAstralMintPaused ? 2 : 0
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_carousel_item, null, {
      default: _withCtx(() => [_createVNode(_component_PublicPanel, {
        class: _normalizeClass({
          active: !_ctx.isPublicMintPaused
        }),
        value: _ctx.publicMintAmount,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.publicMintAmount = $event),
        isWalletConnected: _ctx.isWalletConnected,
        connectWallet: () => _ctx.connectWallet(),
        mint: () => _ctx.handlePublicMint(),
        mintPrice: _ctx.formatUnits(_ctx.publicPrice),
        maxMint: _ctx.walletPublicSlotsRemaining,
        countDownTime: _ctx.countDownTime,
        totalSlots: _ctx.walletPublicTotalSlots,
        isPhasePaused: _ctx.isPublicMintPaused
      }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "mintPrice", "maxMint", "countDownTime", "totalSlots", "isPhasePaused"])]),
      _: 1
    })), [[_directive_touch, () => this.$refs.carousel.next(), "swipe", {
      left: true
    }], [_directive_touch, () => this.$refs.carousel.prev(), "swipe", {
      right: true
    }]]), !_ctx.isPhase1LunarMintPaused ? _withDirectives((_openBlock(), _createBlock(_component_el_carousel_item, {
      key: 0
    }, {
      default: _withCtx(() => [_createVNode(_component_Phase1LunarPanel, {
        class: _normalizeClass({
          active: !_ctx.isPhase1LunarMintPaused
        }),
        value: _ctx.phase1LunarMintAmount,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => _ctx.phase1LunarMintAmount = $event),
        isWalletConnected: _ctx.isWalletConnected,
        connectWallet: () => _ctx.connectWallet(),
        mint: () => _ctx.handlePhase1LunarMint(),
        mintPrice: _ctx.formatUnits(_ctx.lunarPrice),
        maxMint: _ctx.walletPhase1LunarSlotsRemaining,
        totalSlots: _ctx.walletPhase1LunarTotalSlots,
        isPhasePaused: _ctx.isPhase1LunarMintPaused
      }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "mintPrice", "maxMint", "totalSlots", "isPhasePaused"])]),
      _: 1
    })), [[_directive_touch, () => this.$refs.carousel.next(), "swipe", {
      left: true
    }], [_directive_touch, () => this.$refs.carousel.prev(), "swipe", {
      right: true
    }]]) : _withDirectives((_openBlock(), _createBlock(_component_el_carousel_item, {
      key: 1
    }, {
      default: _withCtx(() => [_createVNode(_component_Phase2LunarPanel, {
        class: _normalizeClass({
          active: !_ctx.isPhase2LunarMintPaused
        }),
        value: _ctx.phase2LunarMintAmount,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => _ctx.phase2LunarMintAmount = $event),
        isWalletConnected: _ctx.isWalletConnected,
        connectWallet: () => _ctx.connectWallet(),
        mint: () => _ctx.handlePhase2LunarMint(),
        mintPrice: _ctx.formatUnits(_ctx.lunarPrice),
        maxMint: _ctx.walletPhase2LunarSlotsRemaining,
        countDownTime: _ctx.countDownTime,
        totalSlots: _ctx.walletPhase2LunarTotalSlots,
        isPhasePaused: _ctx.isPhase2LunarMintPaused
      }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "mintPrice", "maxMint", "countDownTime", "totalSlots", "isPhasePaused"])]),
      _: 1
    })), [[_directive_touch, () => this.$refs.carousel.next(), "swipe", {
      left: true
    }], [_directive_touch, () => this.$refs.carousel.prev(), "swipe", {
      right: true
    }]]), _withDirectives((_openBlock(), _createBlock(_component_el_carousel_item, null, {
      default: _withCtx(() => [_createVNode(_component_AstralPanel, {
        class: _normalizeClass({
          active: !_ctx.isAstralMintPaused
        }),
        value: _ctx.astralMintAmount,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => _ctx.astralMintAmount = $event),
        isWalletConnected: _ctx.isWalletConnected,
        connectWallet: () => _ctx.connectWallet(),
        mint: () => _ctx.handleAstralMint(),
        maxMint: _ctx.walletAstralSlotsRemaining,
        countDownTime: _ctx.countDownTime,
        totalSlots: _ctx.walletAstralTotalSlots,
        isPhasePaused: _ctx.isAstralMintPaused
      }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "maxMint", "countDownTime", "totalSlots", "isPhasePaused"])]),
      _: 1
    })), [[_directive_touch, () => this.$refs.carousel.next(), "swipe", {
      left: true
    }], [_directive_touch, () => this.$refs.carousel.prev(), "swipe", {
      right: true
    }]])]),
    _: 1
  }, 8, ["initial-index"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_PublicPanel, {
    class: _normalizeClass({
      active: !_ctx.isPublicMintPaused
    }),
    value: _ctx.publicMintAmount,
    "onUpdate:value": _cache[4] || (_cache[4] = $event => _ctx.publicMintAmount = $event),
    isWalletConnected: _ctx.isWalletConnected,
    connectWallet: () => _ctx.connectWallet(),
    mint: () => _ctx.handlePublicMint(),
    mintPrice: _ctx.formatUnits(_ctx.publicPrice),
    maxMint: _ctx.walletPublicSlotsRemaining,
    countDownTime: _ctx.countDownTime,
    totalSlots: _ctx.walletPublicTotalSlots,
    isPhasePaused: _ctx.isPublicMintPaused
  }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "mintPrice", "maxMint", "countDownTime", "totalSlots", "isPhasePaused"]), !_ctx.isPhase1LunarMintPaused ? (_openBlock(), _createBlock(_component_Phase1LunarPanel, {
    key: 0,
    class: _normalizeClass({
      active: !_ctx.isPhase1LunarMintPaused
    }),
    value: _ctx.phase1LunarMintAmount,
    "onUpdate:value": _cache[5] || (_cache[5] = $event => _ctx.phase1LunarMintAmount = $event),
    isWalletConnected: _ctx.isWalletConnected,
    connectWallet: () => _ctx.connectWallet(),
    mint: () => _ctx.handlePhase1LunarMint(),
    mintPrice: _ctx.formatUnits(_ctx.lunarPrice),
    maxMint: _ctx.walletPhase1LunarSlotsRemaining,
    totalSlots: _ctx.walletPhase1LunarTotalSlots,
    isPhasePaused: _ctx.isPhase1LunarMintPaused
  }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "mintPrice", "maxMint", "totalSlots", "isPhasePaused"])) : (_openBlock(), _createBlock(_component_Phase2LunarPanel, {
    key: 1,
    class: _normalizeClass({
      active: !_ctx.isPhase2LunarMintPaused
    }),
    value: _ctx.phase2LunarMintAmount,
    "onUpdate:value": _cache[6] || (_cache[6] = $event => _ctx.phase2LunarMintAmount = $event),
    isWalletConnected: _ctx.isWalletConnected,
    connectWallet: () => _ctx.connectWallet(),
    mint: () => _ctx.handlePhase2LunarMint(),
    mintPrice: _ctx.formatUnits(_ctx.lunarPrice),
    maxMint: _ctx.walletPhase2LunarSlotsRemaining,
    countDownTime: _ctx.countDownTime,
    totalSlots: _ctx.walletPhase2LunarTotalSlots,
    isPhasePaused: _ctx.isPhase2LunarMintPaused
  }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "mintPrice", "maxMint", "countDownTime", "totalSlots", "isPhasePaused"])), _createVNode(_component_AstralPanel, {
    class: _normalizeClass({
      active: !_ctx.isAstralMintPaused
    }),
    value: _ctx.astralMintAmount,
    "onUpdate:value": _cache[7] || (_cache[7] = $event => _ctx.astralMintAmount = $event),
    isWalletConnected: _ctx.isWalletConnected,
    connectWallet: () => _ctx.connectWallet(),
    mint: () => _ctx.handleAstralMint(),
    maxMint: _ctx.walletAstralSlotsRemaining,
    countDownTime: _ctx.countDownTime,
    totalSlots: _ctx.walletAstralTotalSlots,
    isPhasePaused: _ctx.isAstralMintPaused
  }, null, 8, ["class", "value", "isWalletConnected", "connectWallet", "mint", "maxMint", "countDownTime", "totalSlots", "isPhasePaused"])])], 512), [[_vShow, !_ctx.isPendingApproval && !_ctx.isMinting && !_ctx.isSuccess && !_ctx.hasFailed]]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.isPendingApproval,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.isPendingApproval = $event),
    center: true,
    "align-center": true,
    class: "mint-dialog pending",
    width: "100%"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      text: true,
      class: "close-dialog-button",
      onClick: _cache[8] || (_cache[8] = () => _ctx.isPendingApproval = false)
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    }), _hoisted_14]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.isMinting,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.isMinting = $event),
    center: true,
    "align-center": true,
    class: "mint-dialog minting",
    width: "100%"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      text: true,
      class: "close-dialog-button",
      onClick: _cache[10] || (_cache[10] = () => _ctx.isMinting = false)
    }, {
      default: _withCtx(() => [_hoisted_15]),
      _: 1
    }), _hoisted_16]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.isSuccess,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _ctx.isSuccess = $event),
    center: true,
    "align-center": true,
    class: "mint-dialog success",
    width: "100%"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      text: true,
      class: "close-dialog-button",
      onClick: _cache[12] || (_cache[12] = () => _ctx.isSuccess = false)
    }, {
      default: _withCtx(() => [_hoisted_17]),
      _: 1
    }), _hoisted_18, _createVNode(_component_SuccessComicPage, {
      class: "success-comic-page",
      close: () => _ctx.isSuccess = false
    }, null, 8, ["close"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.hasFailed,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _ctx.hasFailed = $event),
    center: true,
    "align-center": true,
    class: "mint-dialog failed",
    width: "100%"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      text: true,
      class: "close-dialog-button",
      onClick: _cache[14] || (_cache[14] = () => _ctx.hasFailed = false)
    }, {
      default: _withCtx(() => [_hoisted_19]),
      _: 1
    }), _createElementVNode("div", _hoisted_20, [_hoisted_21, _hoisted_22, _ctx.errorMessage ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.errorMessage), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
      text: true,
      onClick: _cache[15] || (_cache[15] = () => _ctx.hasFailed = false),
      class: "try-again-button action-button button"
    }, {
      default: _withCtx(() => [_createTextVNode("TRY AGAIN")]),
      _: 1
    })])]),
    _: 1
  }, 8, ["modelValue"])]);
}